module.exports = __webpack_public_path__ + "static/commission_icon.7816f524.jpg";